import { types } from './actions'

const INITIAL_STATE = {
  current: null,
  walletMovements: [],
  loading: false,
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_SIDE_BAR_PROPS:
      return {
        ...state,
        ...action.meta,
      }

    case types.SET_WALLET_MOVEMENTS:
      return {
        ...state,
        walletMovements: action.payload,
      }

    case types.SET_LOADING:
      return {
        ...state,
        loading: action.meta.loading,
      }

    default:
      return state
  }
}
